export default "__VITE_ASSET__CD06vABt__"